//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import shortId from "short-uuid";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import { $http } from "@/assets/js/appFunc";

export default {
    name: "ImportEntityModal",
    components: {
        AQModal,
        AQUploader,
        AQCard,
        AQDropdown,
        AQCheckbox,
        AQTooltip,
        AQRadio,
        AQChip,
        AQBadge
    },
    props: {
        entityDetails: { type: Object, default: () => {} }
    },
    data() {
        return {
            showModal: true,
            entity: {
                name: "",
                code: ""
            },
            entityData: {},
            fileUploaded: false,
            dataForm: null,
            errorMsg: null,
            isSuccess: false,
            columnsList: [],
            allColumns: true,
            allColumnIDs: [],
            selectedFields: [],
            fileName: "",
            typeOpts: [],
            initialVals: [],
            methodValue: "addNewRows",
            idMethod: "autoGenerateId",
            loadingState: false,
            fileError: false,
            ddlKey: 0,
            importType: "",
            errorMsgImport: null
        };
    },
    computed: {
        setTitle() {
            return this.$t("globalDataModel.importDataLabel", { entityName: this.entityDetails.name });
        },
        importLabel() {
            return {
                label: this.$t("globalDataModel.importEntity")
            };
        }
    },
    methods: {
        ...mapActions("dataStore", ["getEntities"]),
        actionsDlg($event) {
            if ($event === "save") {
                if (!this.fileUploaded) {
                    this.fileError = true;
                } else {
                    this.checkErrorOnSave();
                    const itemError = this.columnsList.find(elem => elem.showError && (!!elem.checked || elem.code === "id"));
                    if (!itemError) {
                        const csvHeadersArray = [];
                        const formattedArray = [];
                        for (let i = 0; i < this.columnsList.length; i++) {
                            for (let j = 0; j < this.selectedFields.length; j++) {
                                if (this.columnsList[i].uuid === this.selectedFields[j]) {
                                    formattedArray.push({
                                        code: this.columnsList[i].code,
                                        name: this.columnsList[i].name,
                                        csvName: this.columnsList[i].csvHeaderSelected,
                                        type: this.columnsList[i].type
                                    });
                                    csvHeadersArray.push(this.columnsList[i].csvHeaderSelected || this.columnsList[i].name);
                                }
                            }
                        }
                        if (this.methodValue === "addNewRows" && this.idMethod === "autoGenerateId") {
                            this.importType = "INSERT_AUTO";
                        } else if (this.methodValue === "addNewRows" && this.idMethod === "idFromFile") {
                            this.importType = "INSERT_MANUAL";
                            const found = this.columnsList.find(el => el.code === "id");
                            formattedArray.push({
                                code: "id",
                                name: "ID",
                                csvName: found.csvHeaderSelected,
                                type: "serial"
                            });
                            csvHeadersArray.push("ID");
                        } else if (this.methodValue === "updateExistingRows") {
                            this.importType = "UPDATE";
                            const found = this.columnsList.find(el => el.code === "id");
                            formattedArray.push({
                                code: "id",
                                name: "ID",
                                csvName: found.csvHeaderSelected,
                                type: "serial"
                            });
                            csvHeadersArray.push("ID");
                        }
                        const payload = {
                            code: this.entityDetails.code,
                            name: this.entityDetails.name,
                            type: "PLATFORM",
                            columns: formattedArray,
                            filename: this.fileName,
                            importType: this.importType,
                            csvHeaders: csvHeadersArray
                        };
                        this.createFromFile(payload);
                    }
                }
            } else if ($event === "close") {
                this.$emit("input", false);
            }
        },
        resetCsvHeaderId() {
            if ((this.methodValue === "addNewRows" && this.idMethod !== "autoGenerateId") || this.methodValue === "updateExistingRows") {
                const found = this.columnsList.find(el => el.code && el.code === "id");
                if (!found) {
                    this.columnsList.unshift({ csvHeaderSelected: "ID", value: "", code: "id", uuid: "id" });
                }
            } else {
                this.columnsList = this.columnsList.filter(el => el.code !== "id");
            }
        },
        uploadFile(file) {
            this.dataForm = new FormData();
            const fileBlob = new Blob([file[0]]);
            this.dataForm.append("file", fileBlob, file[0].name);
            this.loadingState = true;
            $http({
                type: "POST",
                url: `/datastore/csv/upload?importType=INSERT_AUTO&entityCode=${this.entityDetails.code}`,
                noNotify: true,
                data: this.dataForm
            }, true).then(
                (data) => {
                    this.fileError = false;
                    this.loadingState = false;
                    this.fileName = data.data.filename;
                    this.columnsList = data.data.columns.filter(elem => elem.name !== "ID");
                    this.typeOpts = data.data.csvHeaders.map(elem => ({
                        label: elem.trim(),
                        value: elem,
                        badgeProps: {}
                    }));
                    if (this.columnsList.length) {
                        for (let i = 0; i < this.columnsList.length; i++) {
                            this.columnsList[i].uuid = shortId.uuid();
                            this.columnsList[i].checked = true;
                            this.allColumnIDs.push(this.columnsList[i].uuid);
                        }
                    }
                    this.initialVals = JSON.parse(JSON.stringify(data.data.columns));
                    this.selectedFields = [...this.allColumnIDs];
                    this.isSuccess = true;
                    this.fileUploaded = true;
                },
                err => {
                    this.fileError = false;
                    this.loadingState = false;
                    this.setErrors(err.response.data.error);
                }
            );
        },
        setErrors(err) {
            if (err.includes("has duplicated columns")) {
                this.errorMsg = this.$t("globalDataModel.errorDuplicateColumns");
            } else if (err.includes("file is empty")) {
                this.errorMsg = this.$t("globalDataModel.errorFileEmpty");
            } else {
                this.errorMsg = err;
            }
        },
        deleteFile() {
            this.fileUploaded = false;
            this.errorMsg = null;
        },
        showRightIcon(item) {
            let valToReturn = {};
            let result = 0;
            if (item && item.csvHeaderSelected) {
                result = this.columnsList.filter(el => el.csvHeaderSelected === item.csvHeaderSelected && (el.checked || el.code === "id"));
            }
            if (result.length > 1) {
                valToReturn = { name: "warning_amber", size: "24px", color: "#F29500" };
            }
            return valToReturn;
        },
        createFromFile(payload) {
            $http({
                type: "POST",
                noNotify: true,
                url: "/datastore/csv/import",
                data: payload
            }, true).then(
                () => {
                    this.$emit("input", false);
                    this.$toast.showNotify({
                        type: "info",
                        message: this.$t("globalDataModel.importSuccessMsg")
                    });
                },
                err => {
                    if (err.response.status === 400) {
                        this.setErrorOnCreate(err.response.data.error);
                    }
                }
            );
        },
        setErrorOnCreate(err) {
            if (err.includes("one column must be present")) {
                this.errorMsgImport = this.$t("globalDataModel.errorNoColumn");
                this.$toast.showNotify({
                    type: "error",
                    message: this.errorMsgImport,
                    timeout: 500
                });
            } else if (err.includes("Column {code='id', name='ID', csvName='ID', type=serial} is not properly mapped")) {
                this.errorMsgImport = this.$t("globalDataModel.errorNoId");
                this.$toast.showNotify({
                    type: "error",
                    message: this.errorMsgImport,
                    timeout: 500
                });
            }
        },
        changeColumnStatus(data) {
            this.columnsList.forEach(obj => {
                obj.checked = data;
            });
            this.selectedFields = data ? [...this.allColumnIDs] : [];
        },
        triggerCheckboxColumn(item) {
            this.allColumns = this.selectedFields.length === this.allColumnIDs.length;
            const found = this.selectedFields.find(elem => elem === item.uuid);
            if (!found) {
                for (let i = 0; i < this.initialVals.length; i++) {
                    if (item.uuid === this.initialVals[i].uuid) {
                        item.name = this.initialVals[i].name;
                        item.code = this.initialVals[i].code;
                        item.showError = false;
                    }
                }
            }
            item.checked = found;
        },
        showProperties(uuid) {
            let showContainer = false;
            const elToReturn = this.selectedFields.find(elem => elem === uuid);
            if (elToReturn || elToReturn === "" || uuid === "id") {
                showContainer = true;
            }
            return showContainer;
        },
        checkColValuesImport() {
            // eslint-disable-next-line no-useless-escape
            for (let i = 0; i < this.columnsList.length; i++) {
                if (!this.columnsList[i].name) {
                    this.columnsList[i].error = true;
                }
            }
        },
        getChipProps() {
            return {
                type: "default",
                content: this.$t("globalDataModel.autoGeneratedId")
            };
        },
        setBadgeType(item) {
            return item || "String";
        },
        refreshOpts() {
            let arrayToParse = this.columnsList;
            arrayToParse = arrayToParse.filter(el => el.checked || el.code === "id");
            const valuesSet = new Set(arrayToParse.map(item => item.csvHeaderSelected));
            this.typeOpts.forEach(item => {
                item.badgeProps = valuesSet.has(item.value) ? {
                    badgeType: "custom",
                    badgeText: this.$t("globalDataModel.alreadyMapped")
                } : {};
            });
        },
        selectValue(event, item) {
            item.csvHeaderSelected = event[0].value;
            item.showError = false;
        },
        errorLabelDDl(item) {
            let errorMsg;
            if (item.showError) {
                errorMsg = this.$t("globalDataModel.columnMappedError");
            }
            return errorMsg;
        },
        checkErrorOnSave() {
            for (let i = 0; i < this.columnsList.length; i++) {
                if (this.columnsList[i].checked) {
                    this.columnsList[i].showError = !this.columnsList[i].csvHeaderSelected;
                } else if (this.columnsList[i].code === "id") {
                    this.columnsList[i].showError = !this.columnsList[i].csvHeaderSelected;
                }
            }
            this.ddlKey++;
        }
    }

};
